import React from 'react';
import PropTypes from 'prop-types';
// import VirtualSlider from 'react-virtual-slider';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faChevronCircleLeft from '@fortawesome/fontawesome-free-solid/faChevronCircleLeft';
import faChevronCircleRight from '@fortawesome/fontawesome-free-solid/faChevronCircleRight';

import ItemPreview from './common/ItemPreview';
import SliderGalleryItem from '../models/SliderGalleryItem';
import VirtualSlider from './common/VirtualSlider/VirtualSliderComponents';
import './SliderGallery.css';

class SliderGallery extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      windowWidth: window.innerWidth,
    };
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentDidUpdate() {
    if (this.slider) {
      this.slider.scrollTo(0);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  handlePrev = () => {
    this.slider.goBack();
  };

  handleNext = () => {
    this.slider.goNext();
  };

  renderItem = (index, key) => {
    const item = this.props.items[index];

    return <ItemPreview item={item} key={key} />;
  };

  render() {
    const { items, splitAttr } = this.props;
    const { windowWidth } = this.state;

    if (items.length === 0) {
      return <h3 className="sliderGallery-noneMsg">No Items</h3>;
    }

    // Kind of gross, but there doesn't seem to be a way to do this with pure CSS
    let displayableItems = 1;
    if (windowWidth > 768) {
      displayableItems = 2;
    }
    if (windowWidth > 1120) {
      displayableItems = 3;
    }
    if (windowWidth > 1352) {
      displayableItems = 4;
    }

    return (
      <div className="sliderGallery">
        <button
          onClick={this.handlePrev}
          className="sliderGallery-prevButton button is-large is-white"
        >
          <FontAwesomeIcon icon={faChevronCircleLeft} color="#444444" />
        </button>
        <VirtualSlider
          ref={(slider) => {
            this.slider = slider;
          }}
          itemRenderer={this.renderItem}
          itemSize={240}
          length={items.length}
          containerStyle={{
            overflow: 'hidden',
            width: 240 * displayableItems,
          }}
          className="sliderGallery-items"
          extraneousDiffProp={splitAttr}
          extraneousDisplayableItems={displayableItems}
        />
        <button
          onClick={this.handleNext}
          className="sliderGallery-nextButton button is-large is-white"
        >
          <FontAwesomeIcon icon={faChevronCircleRight} color="#444444" />
        </button>
      </div>
    );
  }
}

SliderGallery.propTypes = {
  items: PropTypes.arrayOf(PropTypes.instanceOf(SliderGalleryItem)).isRequired,
  // The following prop is just to force a rerender of VirtualSlider, and this what changes
  splitAttr: PropTypes.string.isRequired,
};

export default SliderGallery;



// WEBPACK FOOTER //
// ./src/components/SliderGallery.jsx